import { createImmutableObjectClass } from 'immutable-less';
export default class SingleObjectCoordinatesField extends createImmutableObjectClass({
  coordinatesToken: null,
  valueType: 'SINGLE_OBJECT_COORDINATES'
}) {
  getIsValueEmpty() {
    return !this.coordinatesToken;
  }
  getValue() {
    return this.coordinatesToken;
  }
  /**
   * @deprecated Prefer dot notation: .valueType
   */
  getValueType() {
    return this.valueType;
  }
}